import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';
import sidebar from '../../../shared/js/lib/sidebar';
import '../../styles/Header';

let Header = React.createClass({
	displayName: 'Header',

	propTypes: {
		isAuthenticated: PropTypes.bool,
		shouldShowHamburger: PropTypes.bool,
		user: PropTypes.object
	},

	shouldComponentUpdate: function(nextProps, nextState) {
		// If the user logs in or out, update, otherwise don't
		return this.props.isAuthenticated !== nextProps.isAuthenticated;
	},

	render: function() {
		return (
			<div className="header">
				<div className="header-left">
					{
						this.props.shouldShowHamburger === false ? '' : (
							<button
								type="button"
								className="btn btn-lg btn-default toggle-sidebar"
								onClick={ sidebar.toggle }
							>
								<i className="fas fa-bars" />
							</button>
						)
					}
					<a className="logo" href="/">
						<img src="/images/olos_logo.png" />
					</a>
				</div>
				{
					this.props.isAuthenticated ? (
						<Dropdown id="account-dropdown">
							<Dropdown.Toggle>
								<div className="user-details">
									<div className="username">
										{ this.props.user.first_name } { this.props.user.last_name }
									</div>
									<div className="user-role">
										{ this.props.user.role }
									</div>
								</div>
								<div className="account-dropdown-caret">
									<i className="fas fa-caret-right" />
								</div>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<li role="presentation"><Link to="/logout">Log out</Link></li>
							</Dropdown.Menu>
						</Dropdown>
					) : ''
				}
			</div>
		);
	}
});

module.exports = Header;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/Header.jsx